/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Slotconfig1Inputs */

const en__field_slotconfig1 = /** @type {(inputs: _Field_Slotconfig1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookingslot config`)
};

const de__field_slotconfig1 = /** @type {(inputs: _Field_Slotconfig1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungsslot Konfiguration`)
};

/**
* | output |
* | --- |
* | "Bookingslot config" |
*
* @param {_Field_Slotconfig1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_slotconfig1 = /** @type {((inputs?: _Field_Slotconfig1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Slotconfig1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_slotconfig1(inputs)
	return de__field_slotconfig1(inputs)
});
export { _field_slotconfig1 as "_field_slotConfig" }